import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AutomationProcessRegisterState } from '../state/automation-process-register.state'

const getAutomationProcessRegisterState =
  createFeatureSelector<AutomationProcessRegisterState>('automationProcessRegister')

export const getAutomationProcessRegisterList = () =>
  createSelector(getAutomationProcessRegisterState, state => {
    return state?.automationRegisterList
  })
